import { UserLang } from '@constants/common';

export const getOnboardingLink = (locale: UserLang) => {
    return `${process.env.GATSBY_AEPSY_APP_URL}/register?lng=${locale}`;
};

export const generateLinkWithExternalParams = (url, apySrc) => {
    const arrayUrl = url.split('?');
    if (arrayUrl.length > 1 && apySrc) {
        const search = arrayUrl[arrayUrl.length - 1];
        const searchArray = search.split('&');

        const newSearchUrl = searchArray.reduce((acc, cur) => {
            if (cur.includes('source') || cur.includes('apy_src')) {
                return acc;
            }
            return `${acc}&${cur}`;
        }, '');

        return `${arrayUrl[0]}?${newSearchUrl}&source=${apySrc}`;
    }

    return url;
};
